var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.813 7.248a.872.872 0 01-.619-.256L.821 4.619A.874.874 0 112.058 3.38l1.755 1.755 4.128-4.128a.874.874 0 111.237 1.238L4.432 6.992a.872.872 0 01-.619.256z",
    fill: "#4CAF50"
  })));
}

export default SvgCheckBlue;